<template>
  <base-notification
    :message="message"
    class="bg-emerald-50 border-emerald-300 text-emerald-900"
  />
</template>

<script>
  import BaseNotification from '@/components/notification/base-notification.vue'

  export default {
    name: 'NotificationSuccess',
    components: { BaseNotification },
    props: {
      message: {
        type: String,
        required: true,
      }
    }
  }
</script>
